import React, { FC, useCallback } from 'react';
import classes from '../../asset/css/subscription-detail/product-info.module.css';
import { ProductInfoType } from '../../types/product-info-type';
import NumberFormat from 'react-number-format';

export const ProductInfo: FC<{
  active: boolean;
  productInfo: ProductInfoType;
  loading: boolean;
  changeActiveFunc: (active: boolean, variantId: string, planId?: string, lineId?: string) => void;
  updateQuantityFunc?: (lineId: string, quantity: number) => void;
}> = ({ active, productInfo, loading, changeActiveFunc, updateQuantityFunc }) => {
  // ＋ボタンを押した時のイベント
  const clickPlusBtnHandler = useCallback(() => {
    if (!updateQuantityFunc || !productInfo.lineId) return;

    updateQuantityFunc(productInfo.lineId, productInfo.quantity + 1);
  }, [productInfo.quantity, productInfo.lineId, updateQuantityFunc]);

  // ーボタンを押した時のイベント
  const clickMinusBtnHandler = useCallback(() => {
    if (!updateQuantityFunc || !productInfo.lineId) return;

    updateQuantityFunc(productInfo.lineId, productInfo.quantity - 1);
  }, [productInfo.quantity, productInfo.lineId, updateQuantityFunc]);

  // 切り替えボタンを押した時のイベント
  const changeActiveHandler = useCallback(() => {
    changeActiveFunc(active, productInfo.variantId, productInfo.planId, productInfo.lineId);
  }, [active, changeActiveFunc, productInfo.lineId, productInfo.planId, productInfo.variantId]);

  let priceHtml = (
    <div className={classes.mypage_subsc_item_price}>
      <div className={classes.mypage_subsc_item_price_org}>
        ￥<NumberFormat displayType="text" value={productInfo.originalPrice} thousandSeparator={true} /> →
      </div>
      <div className={classes.mypage_subsc_item_price_down}>
        ￥<NumberFormat displayType="text" value={productInfo.price} thousandSeparator={true} />
      </div>
    </div>
  );
  if (productInfo.originalPrice === productInfo.price) {
    priceHtml = (
      <div className={classes.mypage_subsc_item_price}>
        <div className={classes.mypage_subsc_item_price_down}>
          ￥<NumberFormat displayType="text" value={productInfo.price} thousandSeparator={true} />
        </div>
      </div>
    );
  }

  return (
    <>
      <li>
        <div className={classes.mypage_subsc_item_main}>
          <div className={classes.mypage_subsc_item_image}>
            <div style={productInfo.image ? { backgroundImage: `url('${productInfo.image}')` } : {}} />
          </div>
          <div className={classes.mypage_subsc_item_info}>
            <h5 className={classes.mypage_subsc_item_name}>{productInfo.productTitle}</h5>
            <div className={classes.mypage_subsc_item_option}>{productInfo.variantTitle}</div>
            {priceHtml}
          </div>
          <div className={classes.mypage_subsc_item_action}>
            <div className={classes.mypage_subsc_item_toggle_wrap}>
              <button
                className={
                  active ? `${classes.mypage_subsc_item_toggle} ${classes.active}` : classes.mypage_subsc_item_toggle
                }
                disabled={loading}
                onClick={changeActiveHandler}
              />
            </div>
            <div className={classes.mypage_subsc_item_adjust}>
              <button
                className={classes.mypage_subsc_item_plus}
                disabled={!active || loading}
                onClick={clickMinusBtnHandler}
              >
                −
              </button>
              <input type="text" className={classes.mypage_subsc_item_amount} value={productInfo.quantity} disabled />
              <button
                className={classes.mypage_subsc_item_minus}
                disabled={!active || loading}
                onClick={clickPlusBtnHandler}
              >
                ＋
              </button>
            </div>
          </div>
        </div>
      </li>
    </>
  );
};
